<template>
  <div :class="$style.column">
    <div :class="$style.header">
      <skeleton-item
        :style="{ height: '20px', width: '72px' }"
        type="bar"
      />
      <skeleton-item
        type="square"
        size="xs"
      />
    </div>
    <div :class="$style.column_content">
      <card-skeleton
        v-for="(card, i) in data.cards"
        :key="`card_skeleton_${data.id}_${i}`"
        :type="card"
      />
      <div :class="$style.content_footer">
        <skeleton-item
          type="square"
          size="sm"
        />
        <skeleton-item
          type="bar"
          :style="{ height: '12px', width: '80px'}"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonItem from '../../common/VueComponents/skeletons/skeletonItem.vue';
import CardSkeleton from './CardSkeleton.vue';

export default {
  name: 'ColumnSkeleton',
  components: {
    SkeletonItem,
    CardSkeleton
  },
  props: {
    data: {
      type: Object,
      default: {
        id: 'default',
        cards: []
      }
    }
  }
}
</script>

<style lang="less" module src="../less/columnSkeleton.less"></style>
